// src/components/DayRitualCore.js
// The canonical "day ritual" block — header, ritual copy, quote, primary CTA — shared between
// AugustToday.js (the Today tab, always showing the current day) and StationEntry.js's august
// branch (revisiting a specific day from Tracklist, or the QA override hatch). Extracted after
// an investigation found these were two independent implementations that had quietly drifted:
// Today had been through every design-refinement pass in this engagement (PageHeader adoption,
// short-preferring ritual text, padding tokens), StationEntry never had, because no prior pass
// ever named it in scope — it predates this whole arc. Rendering through one shared component
// now, instead of two components independently styled to look alike, so they can't drift apart
// the same way again.
// august-only by construction — StationEntry.js's other-city branches (nyc/paris/london/milan/
// berlin/madrid) render their own markup entirely and never import this file.
import React from 'react'
import PageHeader from './ui/PageHeader'
import PullQuoteCard from './PullQuoteCard'
import { isHandwrittenLength } from '../utils/promptLength'

export default function DayRitualCore({
  dayNumber, streak = 0, trackName, ritualText, quote, descriptor,
  ctaLabel, ctaDisabled = false, ctaVisible = true, onCta,
  showBack = false, onBack,
  augustTheme, onAugustThemeChange,
}) {
  return (
    <>
      <PageHeader
        eyebrow={`Day ${dayNumber}${streak > 0 ? ` • ${streak}-day streak` : ''}`}
        title={trackName}
        descriptor={descriptor}
        showBack={showBack} onBack={onBack}
        augustTheme={augustTheme} onAugustThemeChange={onAugustThemeChange}
      />

      <p className={`station-entry-intro${isHandwrittenLength(ritualText) ? ' handwritten' : ''}`}>
        {ritualText}
      </p>

      {quote && <PullQuoteCard text={quote} />}

      <button
        className={`aug-today-cta${ctaDisabled ? ' done' : ''}${ctaVisible ? ' show' : ''}`}
        disabled={ctaDisabled}
        onClick={ctaDisabled ? undefined : onCta}
      >
        {ctaLabel}
      </button>
    </>
  )
}
